import React from 'react';
import { List, Datagrid, TextField, EditButton, DeleteWithConfirmButton, BulkDeleteWithConfirmButton } from 'react-admin';
import {
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@material-ui/core';
import ImageIcon from '@material-ui/icons/Image';
import CloseIcon from '@material-ui/icons/Close';

const BannerModalField = ({ record, source }) => {
  const [open, setOpen] = React.useState(false);
  const imageUrl = record && record[source];

  if (!imageUrl) {
    return <span style={{ color: '#94A3B8', fontSize: '0.8rem' }}>No Image</span>;
  }

  const handleOpen = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setOpen(true);
  };

  const handleClose = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="View Banner Preview">
        <IconButton
          size="small"
          onClick={handleOpen}
          style={{
            backgroundColor: '#EFF6FF',
            color: '#2563EB',
            border: '1px solid #BFDBFE',
            padding: 6,
            borderRadius: 8
          }}
        >
          <ImageIcon style={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        onClick={(e) => e.stopPropagation()}
      >
        <DialogTitle
          disableTypography
          style={{
            backgroundColor: '#1E293B',
            color: '#FFFFFF',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 20px'
          }}
        >
          <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <ImageIcon style={{ color: '#38BDF8', fontSize: 22 }} />
            <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#FFFFFF' }}>
              Banner Preview — {record.bannerName || 'Banner'} {record.bannerType ? `(${record.bannerType})` : ''}
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={handleClose}
            style={{ color: '#94A3B8', padding: 4 }}
          >
            <CloseIcon style={{ fontSize: 20 }} />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: 24, textAlign: 'center', backgroundColor: '#F8FAFC' }}>
          <img
            src={imageUrl}
            alt={record.bannerName || 'Banner Preview'}
            style={{
              maxWidth: '100%',
              maxHeight: '75vh',
              objectFit: 'contain',
              borderRadius: 8,
              boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)'
            }}
          />
        </DialogContent>
        <DialogActions style={{ padding: '12px 20px', backgroundColor: '#F1F5F9', borderTop: '1px solid #E2E8F0' }}>
          <Button
            component="a"
            href={imageUrl}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            variant="outlined"
            style={{ textTransform: 'none', color: '#0284C7', borderColor: '#0284C7' }}
          >
            Open in New Tab
          </Button>
          <Button
            onClick={handleClose}
            size="small"
            variant="contained"
            style={{ textTransform: 'none', backgroundColor: '#1E293B', color: '#FFFFFF' }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const ShowEditButton = ({ record, basePath }) => {
  return record && record.id !== 0 && (
    <>
      <EditButton basePath={basePath} record={record} />
      <DeleteWithConfirmButton basePath={basePath} record={record} />
    </>
  );
};

const BannerBulkActionButtons = (props) => <BulkDeleteWithConfirmButton {...props} />;

export const BannerList = (props) => (
  <List title="Banners" {...props}>
    <Datagrid bulkActionButtons={<BannerBulkActionButtons />}>
      <TextField source="id" label="ID" />
      <TextField source="bannerName" label="Banner Name" />
      <TextField source="bannerType" label="Target Audience" />
      <TextField source="serviceCategory" label="Category" />
      <BannerModalField source="bannerUrl" label="Preview" />
      <ShowEditButton />
    </Datagrid>
  </List>
);
export default BannerList;
